import { render, staticRenderFns } from "./RoleDataTable.vue?vue&type=template&id=256aea22&scoped=true&"
import script from "./RoleDataTable.vue?vue&type=script&lang=js&"
export * from "./RoleDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256aea22",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VPagination,VProgressLinear,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256aea22')) {
      api.createRecord('256aea22', component.options)
    } else {
      api.reload('256aea22', component.options)
    }
    module.hot.accept("./RoleDataTable.vue?vue&type=template&id=256aea22&scoped=true&", function () {
      api.rerender('256aea22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Administrator/components/Role/RoleDataTable.vue"
export default component.exports